/* eslint-disable import/prefer-default-export */
import { useRef, useEffect, useState } from 'react';
import { appInsights } from '../AppInsights';

export const useInterval = (callback:any, delay:number | null, runtime?:number) => {
  const savedCallback = useRef<Function>();
  const [defaultTimer] = useState(new Date().getTime());

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const delayInMs = (delay && (delay * 1000)) || 0;
    // Get Time in milliseconds
    const tick = async () => {
      console.debug('Interval called');

      // Get current time in mil
      const currentTime = new Date().getTime();
      const currentRuntimeInMs = currentTime - defaultTimer;
      const maxRuntimeMs = ((runtime || 3600) * 1000);
      if (currentRuntimeInMs > maxRuntimeMs && interval) {
        console.log('Clearing Interval');
        appInsights.trackTrace({ message: 'Clearing Interval' });
        clearInterval(interval);
        return () => {};
      }

      return typeof savedCallback.current === 'function' && (await savedCallback.current());
    };

    // Start Interval
    const interval = setInterval(tick, delayInMs);
  }, [delay, runtime, defaultTimer]);
};
